import { Box, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      className="d-flex align-items-center justify-content-center"
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(to bottom, #ffffff, #ffe4e6, #ffffff)",
      }}
    >
      {/* Background glow */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(254,202,202,0.3), transparent, rgba(254,202,202,0.4))",
          zIndex: 0,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          zIndex: 1,
          textAlign: "center",
          px: 3,
          maxWidth: 560,
        }}
      >
        {/* Icon */}
        <Box
          className="d-inline-flex align-items-center justify-content-center"
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "#fee2e2",
            boxShadow: "0 10px 25px rgba(239,68,68,0.25)",
            mb: 3,
          }}
        >
          <LockIcon sx={{ fontSize: 40, color: "#ef4444" }} />
        </Box>

        {/* 403 */}
        <Typography
          variant="h1"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "4.5rem", md: "6rem" },
            background: "linear-gradient(to right, #ef4444, #f43f5e, #ec4899)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0 0 20px rgba(239,68,68,0.35)",
          }}
        >
          403
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            mt: 2,
            color: "#555",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.6,
          }}
        >
          You don’t have permission to access this page.
          <br />
          This feature is not enabled for your account.
        </Typography>

        {/* Action */}
        <Button
          variant="outlined"
          color="error"
          sx={{
            mt: 4,
            px: 4,
            py: 1.3,
            borderRadius: "999px",
            textTransform: "none",
            fontWeight: 500,
          }}
          onClick={() => navigate("/DcmTimeTable")}
        >
          ← Back to Dashboard
        </Button>
      </Box>

      {/* Bottom glow line */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: 2,
          background:
            "linear-gradient(to right, transparent, #f43f5e, transparent)",
        }}
      />
    </Box>
  );
};

export default NotAuthorized;
